import React, { useState } from 'react';
import UpgradeModal from './UpgradeModal';

function TrialBar({ quota, gido, openUpgrade, onRefreshQuota }) {
  const [showUpgrade, setShowUpgrade] = useState(!!openUpgrade);

  const trialExpires  = quota?.trial_expires?.toDate
    ? quota.trial_expires.toDate()
    : new Date(quota?.trial_expires);

  const now           = new Date();
  const trialStarted  = quota?.trial_started?.toDate
    ? quota.trial_started.toDate()
    : new Date(quota?.trial_started);

  const totalDays     = quota?.trial_days || 7;
  const daysLeft      = Math.max(Math.ceil((trialExpires - now) / (1000 * 60 * 60 * 24)), 0);
  const daysUsed      = Math.max(totalDays - daysLeft, 0);
  const pctUsed       = Math.min((daysUsed / totalDays) * 100, 100);

  const urgencyClass  = daysLeft <= 1 ? 'urgent' : daysLeft <= 3 ? 'warning' : 'normal';

  return (
    <div className={`trial-bar ${urgencyClass}`}>
      <div className="trial-info">
        <span className="trial-label">
          {daysLeft === 0
            ? '⚠️ Trial expires today!'
            : daysLeft === 1
            ? '⚠️ Last day of trial!'
            : `⏰ ${daysLeft} days remaining in trial`}
        </span>
        <button className="upgrade-link" onClick={() => setShowUpgrade(true)}>
          Upgrade Now →
        </button>
      </div>
      <div className="trial-progress">
        <div
          className="trial-progress-fill"
          style={{ width: `${pctUsed}%` }}
        />
      </div>
      <div className="trial-dates">
        <span>Trial started: {trialStarted.toLocaleDateString()}</span>
        <span>Expires: {trialExpires.toLocaleDateString()}</span>
      </div>
      {showUpgrade && <UpgradeModal gido={gido} quota={quota} onClose={() => setShowUpgrade(false)} onRefreshQuota={onRefreshQuota} />}
    </div>
  );
}

export default TrialBar;